export const TUNNEL_STORE_KEY = 'tunnel';
export const TUNNEL_SERVICE_KEY = 'tunnel';
export const TUNNEL_API_URL = '/api/v1/tunnel/';
